/**
 * The minimal Advanced Scenes version that supports the stopping of scenes on the hub.
 * @type {number}
 */
export const HUB_ADVANCED_SCENES_VERSION_SUPPORTING_HUB_SCENES_STOP = 1.64;

/**
 * Parameters for hub.scenes.list to include all scenes regardless of generator role.
 * @type {Object}
 */
export const HUB_SCENES_LIST_ALL_PARAMS = {
    filters: {
        include: {
            generator: {
                role: 'all',
            },
        },
    },
};

/**
 * The minimal Advanced Scenes version that supports the Global Restrictions feature of scenes on the hub.
 * @type {number}
 */
export const HUB_ADVANCED_SCENES_VERSION_SUPPORTING_HUB_GLOBAL_RESTRICTIONS = 1.71;
